import React from "react";
import { MdLocationOn } from "react-icons/md";

const LocationButton = ({ glass, isLocating, onClick }) => {
    return (
        <div className="absolute bottom-1 right-1 z-[10000]">
            <button
                onClick={onClick}
                disabled={isLocating}
                className={`p-2 rounded-2xl ${glass} text-white shadow-2xl hover:bg-white/20 transition-all duration-200 ${isLocating ? 'opacity-50 cursor-not-allowed' : ''}`}
                title="Get my current location"
            >
                {isLocating ? (
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                ) : (
                    <MdLocationOn className="text-2xl text-green-400" />
                )}
            </button>
        </div>
    );
};

export default LocationButton;


